module.exports = __webpack_public_path__ + "static/media/mob-tennis-banner.c8ce2fcf.webp";